// extracted by mini-css-extract-plugin
export default {"MenuMobile":"styles_MenuMobile__pXKmG","Header":"styles_Header__TkRPr","MenuItems":"styles_MenuItems__-+NEv","LanguageSelector":"styles_LanguageSelector__M1Vig"};